exports.breakpoints = { sm: 360, mid: 640, highmed: 768, lg: 1024, height: 640, pill: 70 }

// Don't forget to update ../analytics/pageMaps.js if you create/move pages
exports.LandingPageNumber = 0
exports.VehiclePageNumber = 1
exports.OptionsPageNumber = 2
exports.AftermarketPageNumber = 3
exports.HistoryPageNumber = 4
exports.ImageCapturePageNumber = 5
exports.ExteriorPageNumber = 6
exports.GlassPageNumber = 7
exports.InteriorPageNumber = 8
exports.MechanicalPageNumber = 9
exports.ContactPageNumber = 10
exports.InprogressOfferPageNumber = 11
exports.SummaryPageNumber = 12
exports.LoadingPageNumber = 13
exports.CertificatePageNumber = 14

exports.MILEAGE_LOW_WARNING = 'The entered mileage is less than what we have on record. Please confirm before continuing.'
exports.MILEAGE_HIGH_WARNING = 'The entered mileage is higher than expected. Please confirm before continuing.'

// XML format constants
exports.XML_FORMAT_STELLANTIS = '29'
exports.XML_FORMAT_MAZDA = '38'